import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import type { ConfirmationActionProps } from '../model';

type TriggerProps = Pick<
  ConfirmationActionProps,
  'trigger' | 'triggerText' | 'triggerVariant' | 'triggerClassName' | 'triggerDisabled' | 'isLoading' | 'loadingText'
>;

export function Trigger({
  trigger,
  triggerText,
  triggerVariant = 'default',
  triggerClassName,
  triggerDisabled = false,

  isLoading = false
}: TriggerProps) {
  const { t } = useTranslation();

  if (trigger) {
    return trigger;
  }

  return (
    <Button variant={triggerVariant} className={triggerClassName} disabled={triggerDisabled || isLoading}>
      {triggerText || t('common.action')}
    </Button>
  );
}
